var _style, _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 350 100",
    style: {
      enableBackground: "new 0 0 350 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000089558249475918107220000008450251229687398787_);fill:#00A4DF;}\n\t.st1{clip-path:url(#SVGID_00000089558249475918107220000008450251229687398787_);fill:#FFFFFF;}\n\t.st2{clip-path:url(#SVGID_00000089558249475918107220000008450251229687398787_);fill:#006633;}\n\t.st3{clip-path:url(#SVGID_00000089558249475918107220000008450251229687398787_);fill:#95C11F;}\n\t.st4{clip-path:url(#SVGID_00000089558249475918107220000008450251229687398787_);fill:#FFEE00;}\n\t.st5{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "znak"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 50,
    cy: 50,
    r: 50
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000164477128443162202660000015454188952649444741_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000164477128443162202660000015454188952649444741_)",
      fill: "#00A4DF"
    },
    cx: 50,
    cy: 50,
    r: 50
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000164477128443162202660000015454188952649444741_)",
      fill: "#FFFFFF"
    },
    d: "M19,44 c44.74,0,81,36.26,81,81s-36.26,81-81,81s-81-36.26-81-81S-25.74,44,19,44 M19,39c-47.42,0-86,38.58-86,86s38.58,86,86,86 s86-38.58,86-86S66.42,39,19,39L19,39z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000164477128443162202660000015454188952649444741_)",
      fill: "#006633"
    },
    cx: 19,
    cy: 125,
    r: 81
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000164477128443162202660000015454188952649444741_)",
      fill: "#FFFFFF"
    },
    d: "M86,55 c44.74,0,81,36.26,81,81s-36.26,81-81,81S5,180.74,5,136S41.26,55,86,55 M86,50C38.58,50,0,88.58,0,136s38.58,86,86,86 s86-38.58,86-86S133.42,50,86,50L86,50z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000164477128443162202660000015454188952649444741_)",
      fill: "#95C11F"
    },
    cx: 86,
    cy: 136,
    r: 81
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000164477128443162202660000015454188952649444741_)",
      fill: "#FFFFFF"
    },
    d: "M24-44 c17.12,0,31,13.88,31,31S41.12,18,24,18S-7,4.12-7-13S6.88-44,24-44 M24-49C4.15-49-12-32.85-12-13S4.15,23,24,23S60,6.85,60-13 S43.85-49,24-49L24-49z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000164477128443162202660000015454188952649444741_)",
      fill: "#FFEE00"
    },
    cx: 24,
    cy: -13,
    r: 31
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logotyp"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M130,46.95l16.75-25.29H130.6v-5.8h26.71v1.81L141.17,42.9h15.98v5.8H130V46.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M180.42,48.7h-6.62V15.86h6.62V48.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M221.47,35.07h-15.55v7.83h18.89v5.8H199.3V15.86h25.51v5.8h-18.89v7.99h15.55V35.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M268.66,29.32l-9.52,9.63h-1.31l-9.58-9.63V48.7h-6.62V15.86h1.81l14.94,14.73l15.11-14.73h1.75V48.7h-6.57 V29.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M300.68,48.7h-6.62V15.86h6.62V48.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M331.94,15.86h1.15L350,48.7h-7.5l-2.14-4.49h-15.71l-2.08,4.49h-7.5L331.94,15.86z M332.7,27.85h-0.44 l-4.98,10.73l-0.38,0.71h11.17l-0.38-0.71L332.7,27.85z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M133.64,83.75H130V65.68h3.64V83.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M160.67,83.75h-0.87l-12.11-11.02v11.02h-3.64V65.68h0.9l12.11,10.78V65.71h3.62V83.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M180.85,65.68h1.02l3.19,8.37l0.66,2.2h0.45l0.69-2.41l3.01-8.16h3.98l-7.38,18.07h-1.14l-3.25-8.43 l-0.54-1.72h-0.39l-0.54,1.72l-3.31,8.43h-1.08l-7.38-18.07h3.95l3.04,8.16l0.66,2.41h0.45l0.69-2.2L180.85,65.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M214.2,76.25h-8.56v4.31h10.39v3.19H202V65.68h14.04v3.19h-10.39v4.4h8.56V76.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M226.04,79.05c0,0,2.38,1.75,5.33,1.75c2.2,0,3.07-0.87,3.07-2.02c0-1.17-0.78-1.78-3.92-2.65 c-4.1-1.14-6.24-2.59-6.24-5.48c0-3.22,2.41-5.36,7.05-5.36c4.85,0,6.84,1.87,6.84,1.87l-1.96,2.98c0,0-1.93-1.51-4.88-1.51 c-1.99,0-2.95,0.69-2.95,1.81c0,1.08,0.93,1.57,3.77,2.35c4.43,1.17,6.45,2.74,6.45,5.66c0,3.16-2.2,5.69-7.14,5.69 c-4.97,0-7.41-2.32-7.41-2.32L226.04,79.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M245.98,65.68h15.42v3.19h-5.87v14.88h-3.65V68.87h-5.9V65.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M280.74,65.68h4.22l-6.84,11.17v6.9h-3.65v-6.93l-6.78-11.14h4.22l3.74,6.3l0.51,1.14h0.33l0.54-1.14 L280.74,65.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M306.92,81.91c0,0-2.02,2.23-6.39,2.23c-5.9,0-9.61-4.22-9.61-9.43c0-5.21,3.7-9.43,9.61-9.43 c4.4,0,6.39,2.23,6.39,2.23l-2.08,2.8c0,0-1.87-1.54-4.25-1.54c-3.46,0-5.9,2.5-5.9,5.93c0,3.43,2.44,5.96,5.9,5.96 c2.74,0,4.25-1.57,4.25-1.57L306.92,81.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M315.57,79.59c0,0,1.51,0.99,3.16,0.99c2.29,0,3.37-1.08,3.4-3.7V65.68h3.65V77.6 c-0.03,3.62-2.02,6.54-6.78,6.54c-3.19,0-4.91-1.33-5.09-1.48L315.57,79.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M348.16,76.25h-8.56v4.31H350v3.19h-14.04V65.68H350v3.19h-10.39v4.4h8.56V76.25z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logoDark.92241f122e16b71a4678abd12770f167.svg";
export { ForwardRef as ReactComponent };